import styled from 'styled-components'
import { Form } from 'formik'

import CommonButton from 'components/Button/CommonButton'
import { TextField } from 'components/Fields'

export const ClaimDeviceManuallyFormWrapper = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const ClaimDevicePrimaryButton = styled(CommonButton)`
  align-self: center;
  min-width: 110px;
  height: 40px;
`

export const ClaimDeviceTextField = styled(TextField)`
  min-width: 320px;
  margin-bottom: 16px;
`
